import React from "react";

interface Props {
  className?: string;
}

const Loader: React.FC<Props> = ({ className }) => {
  return (
    <div
      className={`
          mx-auto
          h-[48px]
          w-[48px]
          bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjI1IDI1IDUwIDUwIiBjbGFzcz0ic3Bpbm5lciI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Bpbm5lciB7dHJhbnNmb3JtLW9yaWdpbjogY2VudGVyIGNlbnRlcjthbmltYXRpb246IHNwaW5uZXItcm90YXRlIDJzIGxpbmVhciBpbmZpbml0ZTt9LnNwaW5uZXJfX2NpcmNsZSB7c3Ryb2tlLWRhc2hhcnJheTogODksIDIwMDtzdHJva2UtZGFzaG9mZnNldDogMDthbmltYXRpb246IHNwaW5uZXItZGFzaCAxLjVzIGVhc2UtaW4tb3V0IGluZmluaXRlO3N0cm9rZS1saW5lY2FwOiByb3VuZDt9QGtleWZyYW1lcyBzcGlubmVyLXJvdGF0ZSB7dG8ge3RyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7fX1Aa2V5ZnJhbWVzIHNwaW5uZXItZGFzaCB7MCUge3N0cm9rZS1kYXNoYXJyYXk6IDEsIDIwMDtzdHJva2UtZGFzaG9mZnNldDogMDt9NTAlIHtzdHJva2UtZGFzaGFycmF5OiA4OSwgMjAwO3N0cm9rZS1kYXNob2Zmc2V0OiAtMzVweDt9MTAwJSB7c3Ryb2tlLWRhc2hhcnJheTogODksIDIwMDtzdHJva2UtZGFzaG9mZnNldDogLTEyNHB4O319PC9zdHlsZT48Y2lyY2xlIGNsYXNzPSJzcGlubmVyX19jaXJjbGUiIHN0cm9rZT0iI2U5MDQxZSIgY3g9IjUwIiBjeT0iNTAiIHI9IjIwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGZpbGw9Im5vbmUiIHN0cm9rZS13aWR0aD0iNCI+PC9jaXJjbGU+PC9zdmc+')]
          bg-auto
          bg-center
          bg-no-repeat
          sm:h-[64px]
          sm:w-[64px]
         ${className} `}
    />
  );
};

export default Loader;
